import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { useArchiveFileReadQueryPromise } from '@isyc-react/oc-api';
import { downloadPDF } from "../../utils/download.pdf";
import React from 'react';
import { useGenerateProgramRecordDocument } from "../../common/api/graphql";

//TODO: Default runner

export const AcademicProgramDownloadPdf = props => {
  const {
    Runner,
    programRecordId
  } = props;
  const {
    user
  } = useAuthContext();
  const [generateDocument] = useGenerateProgramRecordDocument();
  const archiveFileReadQuery = useArchiveFileReadQueryPromise();
  const [isDownloading, setIsDownloading] = React.useState(false);
  const onDownload = () => {
    setIsDownloading(true);
    generateDocument({
      variables: {
        expedient_id: programRecordId
      }
    }).then(d => {
      if (d.errors) {
        //TODO: Show error notification
        return;
      }
      archiveFileReadQuery({
        id: d.data.programRecord_generateDocument.ID
      }).then(d2 => {
        var _user$person;
        const base64 = d2.data.archive_readFile.content;
        const fileName = (user === null || user === void 0 || (_user$person = user.person) === null || _user$person === void 0 ? void 0 : _user$person.name) + '-' + programRecordId;
        downloadPDF(fileName, base64);
      });
    }).finally(() => {
      setIsDownloading(false);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Runner, {
    isDownloading: isDownloading,
    download: onDownload
  }));
};